import { Input, Directive } from '@angular/core';

/** Base inputs for data displayer used on single record screens.
 * Use the CSS file dataDisplayer.css by importing it into derived components. */
@Directive()
export abstract class DataDisplayerBase<T> {
    @Input() data: T[];
    @Input() columns: string[];
    @Input() isAdmin = false;
    @Input() tooltipDelay = 500; // ms

}
